export default "__VITE_ASSET__BS6nCOln__"